import { render, staticRenderFns } from "./terms-condition-com.vue?vue&type=template&id=5523ebd0&scoped=true"
import script from "./terms-condition-com.vue?vue&type=script&lang=js"
export * from "./terms-condition-com.vue?vue&type=script&lang=js"
import style0 from "./terms-condition-com.vue?vue&type=style&index=0&id=5523ebd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523ebd0",
  null
  
)

export default component.exports